import {
    CUP_BASE_KES,
    CUSTOM_NAME_KES,
    PACK_SIZE,
    STICKER_KES,
} from "@/data/merchCups";

/** Normalize DB/API entry: object `{ team, name }` or legacy team id string. */
export function normalizeCupLine(entry) {
    if (entry && typeof entry === "object" && !Array.isArray(entry)) {
        const team = entry.team || null;
        const nameRaw = (entry.name ?? "").toString().trim();
        return {
            team,
            name: team && nameRaw ? nameRaw : null,
        };
    }
    const team = entry || null;
    return { team, name: null };
}

/**
 * Plain: 20 · Sticker (team): 40 · Sticker + name: 50
 */
export function pricePerCupLine(line) {
    const { team, name } = normalizeCupLine(line);
    let total = CUP_BASE_KES;
    if (team) {
        total += STICKER_KES;
        if (name) {
            total += CUSTOM_NAME_KES;
        }
    }
    return total;
}

export function calculateOrderTotal(packs, cupLines) {
    const count = Math.max(0, packs) * PACK_SIZE;
    const lines = (cupLines || []).slice(0, count).map(normalizeCupLine);
    while (lines.length < count) {
        lines.push({ team: null, name: null });
    }

    let subtotal = 0;
    const perCupBreakdown = lines.map((line, index) => {
        const lineKes = pricePerCupLine(line);
        subtotal += lineKes;
        return {
            index: index + 1,
            team: line.team,
            name: line.name,
            baseKes: CUP_BASE_KES,
            stickerKes: line.team ? STICKER_KES : 0,
            nameKes: line.team && line.name ? CUSTOM_NAME_KES : 0,
            lineKes,
        };
    });

    return {
        packs: Math.max(0, packs),
        cups: count,
        subtotalKes: subtotal,
        perCupBreakdown,
        cupLines: lines,
    };
}

export function formatKes(amount) {
    return `KES ${Number(amount).toLocaleString("en-KE")}`;
}

export function describeCupLine(line, eplTeams = []) {
    const { team, name } = normalizeCupLine(line);
    if (!team) return "Plain (no sticker)";
    const label = eplTeams.find((t) => t.id === team)?.name || team;
    if (name) return `${label} + “${name}”`;
    return `${label} (sticker)`;
}

/** @deprecated */
export function pricePerCup(teamId) {
    return pricePerCupLine({ team: teamId, name: null });
}
